export default __webpack_public_path__ + "static/media/diamond-cut-5.76c67dc7.jpg";